<!--
 * @Author: Gaho
 * @Date: 2024-02-26 13:46:41
 * @LastEditors: Gaho
 * @LastEditTime: 2025-01-21 17:11:35
 * @Description: 
-->
<template>
    <div class="card-help-bg"></div>
    <div class="card-wild-text">
        <img src="@/assets/imgs/casino/corgiwild/w.webp" class="card-wild-text-img" alt="">
        <img src="@/assets/imgs/casino/corgiwild/i.webp" class="card-wild-text-img" alt="">
        <img src="@/assets/imgs/casino/corgiwild/l.webp" class="card-wild-text-img" alt="">
        <img src="@/assets/imgs/casino/corgiwild/d.webp" class="card-wild-text-img" alt="">
        <img src="@/assets/imgs/casino/corgiwild/wild-decor.webp" class="card-wild-decor-img" alt="">
    </div>
    <div class="card-bg card-wild-img">
        <img src="@/assets/imgs/casino/corgiwild/wild-corgi.webp" alt="">
    </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'corgiwild-card-wild',
})
</script>
<style lang="scss" scoped>
.card-help-bg {
    border-radius: 14px;
    bottom: 7px;
    left: 7px;
    overflow: hidden;
    position: absolute;
    right: 7px;
    top: 7px;
    &::after {
        background-image: url(@/assets/imgs/casino/corgiwild/lines-wild.webp);
        content: "";
        height: 128px;
        left: 50%;
        position: absolute;
        top: 50%;
        transform: translate(-50%,-70%);
        width: 128px;
    }
}
.card-wild-text {
    .card-wild-text-img {
        position: absolute;
        z-index: 3;
        &:first-child {
            animation-delay: .4s;
            bottom: 5%;
            height: 42%;
            left: 4%;
        }
        &:nth-child(2){
            animation-delay: .8s;
            bottom: 17%;
            height: 38%;
            left: 46%;
        }
        &:nth-child(3){
            animation-delay: 1.2s;
            bottom: 19%;
            height: 35%;
            left: 59%;
        }
        &:nth-child(4) {
            animation-delay: 1.6s;
            bottom: 21%;
            height: 36%;
            left: 72%;
        }
    }
    .card-wild-decor-img {
        bottom: 3%;
        height: 25%;
        position: absolute;
        right: 8%;
        z-index: 4;
    }
}
.card-wild-img {
    overflow: visible !important;
    img {
        left: 50%;
        max-width: 110%;
        top: 50%;
        transform: translate(-50%,-50%);
        position: absolute;
        z-index: 2;
    }
}
</style>
